var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip364_2082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip364_2082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4062 11.7266C26.2119 11.7266 26.0542 11.5691 26.0542 11.3745C26.0542 11.1802 26.2119 11.0225 26.4062 11.0225C26.6006 11.0225 26.7583 11.1802 26.7583 11.3745C26.7583 11.5691 26.6006 11.7266 26.4062 11.7266Z",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09375 33.7188L6.09375 10.9688C6.09375 9.89136 6.52197 8.85791 7.28369 8.09619C8.04541 7.33423 9.07861 6.90625 10.1562 6.90625L42.6562 6.90625C43.7339 6.90625 44.7671 7.33423 45.5288 8.09619C46.2905 8.85791 46.7188 9.89136 46.7188 10.9688L46.7188 33.7188",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9062 41.8438L19.9062 41.8438L19.9062 38.5938L2.03125 38.5938L2.03125 39.4062C2.03125 41.1301 2.71631 42.7834 3.93506 44.0024C5.15381 45.2214 6.80713 45.9062 8.53125 45.9062L44.2812 45.9062C46.0054 45.9062 47.6587 45.2214 48.8774 44.0024C50.0967 42.7834 50.7812 41.1301 50.7812 39.4062L50.7812 38.5938L32.9062 38.5938L32.9062 41.8438Z",
    stroke: "#EBBE7B",
    strokeOpacity: 1,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.3fac49f324a44065ea210b474a71075a.svg";
export { ForwardRef as ReactComponent };